/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'btn-arrow-2': {
    width: 17,
    height: 18,
    viewBox: '0 0 17 18',
    data: '<g clip-path="url(#clip0_123_828)"><path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.2.288a1 1 0 00-.01 1.414l6.67 6.769H1a1 1 0 000 2h11.648l-6.416 5.786a1 1 0 001.34 1.486l8.348-7.53a1 1 0 00.042-1.444L7.614.299A1 1 0 006.2.287z" _fill="#E32112"/></g><defs><clipPath id="clip0_123_828"><path pid="1" _fill="#fff" d="M0 0h17v18H0z"/></clipPath></defs>'
  }
})
